import axios from "axios";

const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL;
// On a custom domain (e.g. portal.kennyspizza.com) call the API on that same domain.
const BACKEND_URL =
  new URL(CONFIGURED_URL).host === window.location.host ? CONFIGURED_URL : window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function apiError(e, fallback = "Something went wrong") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return e?.message || fallback;
}
